import { Funnel } from "@phosphor-icons/react";
import { m } from "@plannello/i18n/messages";
import { createFileRoute } from "@tanstack/react-router";
import { validateViewSearch } from "@/components/items/viewSearch";
import { WorkView } from "@/components/items/WorkView";
import { useRunCommand } from "@/components/shell/useRunCommand";
import { Button, EmptyState, Kbd, KeyHint } from "@/components/ui";

export const Route = createFileRoute("/_app/triage")({ validateSearch: validateViewSearch, component: Triage });

const SORT = [{ key: "created" as const, dir: "desc" as const }];

/**
 * New items waiting for a decision: status "triage" (a backlog-category status), newest first.
 * 1 to 4 set the priority, S moves the item on (accept into Backlog or Todo, or cancel).
 */
function Triage() {
  const search = Route.useSearch();
  const run = useRunCommand();
  return (
    <WorkView
      title={m.nav_triage()}
      icon={Funnel}
      meta={m.triage_meta()}
      baseQuery="status:triage"
      search={search}
      defaultGroup="none"
      defaultSort={SORT}
      defaultSortParam="created"
      viewKey="triage"
      hints={
        <span className="flex items-center gap-3 max-lg:hidden">
          <KeyHint keys={["1", "2", "3", "4"]}>{m.triage_hint_priority()}</KeyHint>
          <KeyHint keys={["S"]}>{m.triage_hint_status()}</KeyHint>
        </span>
      }
      empty={
        <EmptyState
          title={m.triage_empty_title()}
          description={m.triage_empty_body()}
          action={
            <Button variant="primary" onPress={() => run("create")}>
              {m.action_create_item()}
              <Kbd keys={["C"]} tone="inverse" className="-mr-1 ml-1" />
            </Button>
          }
          secondary={
            <Button variant="secondary" onPress={() => run("import.github")}>
              {m.import_github()}
            </Button>
          }
          hint={<KeyHint keys={["mod", "K"]}>{m.hint_command_palette()}</KeyHint>}
        />
      }
    />
  );
}
